export const params = {
  dataType: "THERMAL_IMAGE",
  deviceType: "fc3550",
  from: 1522141651978,
  to: 1528812031285,
  dataPoints: 150,
  frequency: "ALL",
  sessionStartTime: 1522141651978,
  sessionEndTime: 1528812031285,
  unit: "F",
  assetId: "13b97765-58f5-4b3d-b5d7-0d2fa0fde410",
  sessionId: "8b811b74-a639-4f16-ae6e-2ee22470e0f8"
};

